import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from 'react'
import { PROMOTED_JOBS_END_URL } from '../constants/all'
import useTranslation from '../hooks/useTranslation'
import { APIGet } from '../utils/ApiClient'
import { AboutJob } from './AboutJob'
import { CircularSpinner } from './CircularSpinner'
import { ComponentsHeader } from './ComponentsHeader'
import { Pagination } from './Pagination'
import { Media } from '../commonComponents/Media'
import ImageWithBasePath from './ImageWithBasePath'
import { SharedContext } from '../context/SharedContext'

export const SponsoredJobsScreen = ({ setShowSponsoredJobs }) => {
  const [pagination, setPagination] = useState({ pageNumber: 1, hasMore: true })
  const [sponsoredJobsObject, setSponsoredJobsObject] = useState({})
  const { location, isMenuClicked, language } = useContext(SharedContext)
  const translation = useTranslation()
  const router = useRouter()

  useEffect(() => {
    router.events.on('routeChangeComplete', () => {
      if (!isMenuClicked) setShowSponsoredJobs(false)
    })
    return () =>
      router.events.off('routeChangeComplete', () => {
        if (!isMenuClicked) setShowSponsoredJobs(false)
      })
  }, [isMenuClicked])

  const fetchNextJobDetails = async () => {
    const data = await APIGet(
      PROMOTED_JOBS_END_URL,
      { 'Accept-Language': language, source: 'jobs_web', 'App-Type': 'web' },
      {
        page: pagination.pageNumber + 1,
        location_id: location?.district_id || 9,
        category_id: 2
      }
    )
    if (data?.results?.length > 0)
      setSponsoredJobsObject((prv) => {
        let results
        if (prv?.results) results = [...prv?.results, ...data?.results]
        else results = data?.results
        prv.results = results
        return { ...prv }
      })
    else setPagination((prv) => ({ ...prv, hasMore: false }))
    setPagination((prv) => ({ ...prv, pageNumber: prv.pageNumber + 1 }))
  }

  const sponsoredJobsDataHandler = async () => {
    const params = { page: 1, location_id: location?.district_id || 9, category_id: 2 }
    const sponsoredJobsObjectData = await APIGet(
      PROMOTED_JOBS_END_URL,
      { 'Accept-Language': language, source: 'jobs_web', 'App-Type': 'web' },
      params
    )
    setSponsoredJobsObject(sponsoredJobsObjectData)
    if (sponsoredJobsObjectData?.results?.length < 3) {
      setPagination((prev) => ({ ...prev, hasMore: false }))
    }
  }

  const backNavigation = () => {
    setShowSponsoredJobs(false)
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', () => {
      if (!isMenuClicked) setShowSponsoredJobs(false)
    })
    return () => {
      router.events.off('routeChangeComplete', () => {
        if (!isMenuClicked) setShowSponsoredJobs(false)
      })
    }
  }, [isMenuClicked])

  useEffect(() => {
    sponsoredJobsDataHandler()
  }, [])

  return (
    <div className=" bg-[#F8F8F8] sm:px-[40px] sm:pt-[30px] md:px-[80px] md:pt-[60px]">
      <Media at="sm" className="sticky top-0 ">
        <ComponentsHeader backNavigation={backNavigation} title="Sponsored Jobs" />
      </Media>
      <div>
        <div className="sm:flex sm:items-center">
          <Media greaterThan="sm">
            <div onClick={backNavigation} className="mr-[9px]">
              <ImageWithBasePath
                src={'post_job_back'}
                width={24}
                height={24}
                alt="back button arrow"
              />
            </div>
          </Media>
          <div
            className="select-none pl-[12px] pt-[12px] font-noto-sans text-lg font-bold leading-[28.8px] sm:p-[0px]"
            id="sponsored_jobs_container"
          >
            {translation.sponsoredJobs}
          </div>
        </div>
        {sponsoredJobsObject?.results?.length > 0 && (
          <>
            <Pagination
              listLength={sponsoredJobsObject?.results?.length}
              next={fetchNextJobDetails}
              hasMore={pagination.hasMore}
              loader={<CircularSpinner />}
              className="overflow-hidden"
            >
              <div className="mx-[12px] sm:mx-[0px]" id="sponsored_jobs_data">
                {sponsoredJobsObject?.results?.map((item, index) => (
                  <div key={index} className="sm:w-[540px] md:w-[740px]">
                    <AboutJob jobDetails={item} key={index} />
                  </div>
                ))}
              </div>
            </Pagination>
          </>
        )}
      </div>
    </div>
  )
}
